import React from 'react';
import {Typography, Box, Button} from '@mui/material';
import {Link} from 'react-router-dom';

interface ConfirmEmailMessageProps {
    isConfirmed: boolean | null;
    error: string | null;
}

const ConfirmEmailMessage: React.FC<ConfirmEmailMessageProps> = ({isConfirmed, error}) => {
    return (
        <Box sx={{marginTop: 8, display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
            <Typography component="h1" variant="h5">
                {isConfirmed ? 'Email подтвержен' : 'Ошибка подтверждения Email'}
            </Typography>
            <Typography sx={{mt: 2, mb: 2}}>
                {isConfirmed
                    ? 'Ваш email успешно подвтержен. Вы можете перейти к авторизации.'
                    : error}
            </Typography>
            <Button component={Link} to="/login" variant="contained" color="primary">
                Перейти к авторизации
            </Button>
        </Box>
    );
};

export default ConfirmEmailMessage;